/* eslint-disable no-unused-vars */

import { Grid } from '@material-ui/core'
import { Typography,Container, useMediaQuery, useTheme, createTheme } from '@mui/material'
import React from 'react'
import ValueCard from './ValueCard'
import Slider from "react-slick";
import Header from '../content-component/Header';

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL

const icon1 =imageBaseUrl + 'value1.svg';
const icon2 =imageBaseUrl + 'value2.svg';
const icon3 =imageBaseUrl + 'value3.svg';
const icon4 =imageBaseUrl + 'value4.svg';


const OurValue = () => {
    const theme = useTheme();
    const isSmScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    const isFullScreen = useMediaQuery((theme) => theme.breakpoints.down("lg"));
    const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
    const largeScreen = createTheme({
      breakpoints: {
        values: {
          xxl: 1920,
        },
      },
    });
    const isLargeScreen = useMediaQuery(largeScreen.breakpoints.up("xxl"));

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: isSmScreen ? 1 : 4,
        slidesToScroll: 3,
        arrows: isMediumScreen ?  true : isSmScreen ? true : false ,
        autoPlay: true,
        autoplaySpeed: 500,
        adaptiveHeight:true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
        
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
         
            },
          },
        ],
      };

    const valueCardData = [
        {
          id: 1,
          icon: icon1,
          title: "Expert Guidance",
          about: "Our experienced counselors stay updated on the latest admission trends, top universities, and scholarship opportunities. Whether you aim for an undergraduate degree, master’s, or MBBS, we provide the best advice to help you succeed."
        },
        {
          id: 2,
          icon: icon2,
          title: "Personalized Support",
          about: "Every student is unique. We take time to understand your interests, strengths, and career goals, offering tailored guidance to match your academic journey."
        },
        {
          id: 3,
          icon: icon3,
          title: "Proven Track Record",
          about : "As leading MBBS abroad consultants in Greater Noida, we have successfully placed many students in top international universities. Our success stories speak for themselves"
        },
        {
          id: 4,
          icon: icon4,
          title: "Local Expertise with a Global Vision",
          about: "Based in Greater Noida, we understand the needs of students here. We provide valuable insights on the best study options and help you explore the advantages of global education"
        },
      ];
    return (
        <Container 
        sx={{
          // marginTop:'5vh',
          padding:"50px 0",
          height : "auto",
          // height: {xs:'auto',md:'100vh',lg:'90vh',xl:'80vh', xxl: '80vh'},
          // width: {xs:'80%',lg:'auto'},
          width : "100%"
        }}
        maxWidth={isLargeScreen?"xl":"lg"}
        >
        <Grid container
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            direction="column"
        > <Header
                        color="#00999e"
                        textAlign="center"
                        content="Why Choose Taksheela?"
                    />
        {/* <Typography
            variant="h1"
            gutterBottom
            sx={{
                color: "#00999E",
                fontSize: "36px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "normal",
                textTransform: "capitalize",
                textAlign: "center",
                mb:4
            }}
        >
            ~Our Values~
        </Typography> */}
       {  <Typography
            variant="subtitle1"
            gutterBottom
            sx={{
                color: "#1E1E1E",
                fontSize: { xs: "14px", sm: "18px", md: "20px", lg: "19px" },
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "1.5",
                textTransform: "capitalize",
                textAlign: "center",
                width: { xs: "100%", sm: "80%", md: "80%", lg: "80%" },
                margin: "auto"
            }}
        >
            Studying abroad is a life-changing opportunity. It opens doors to top universities, better career prospects, and global exposure. But the process can feel overwhelming. That’s where we come in! We make your journey simple, smooth, and stress-free.  
          </Typography>}

        <Container
        style={{ 
            height: "100%",
            // padding: "60px 0",
            justifyContent: isSmScreen?"center":isMediumScreen?"center":"space-between",
            alignItems:"center",
        }}
        maxWidth={isLargeScreen?"xl":"auto"}
        ><div
        style={{
            gap: "2rem",
            justifyContent: "center",
            margin:"auto",
            height: "415px",
            display: "flex"
        }}
    > <Slider {...settings} >
            {
                valueCardData.map((card)=>(
                    <ValueCard 
                    key={card.id}
                    id={card.id}  
                    icon={card.icon}
                    title={card.title}
                    about={card.about}
                    />
                ))
            }
            </Slider>
            </div>
        </Container>
    </Grid>
        </Container>
    )
}

export default OurValue